<template>
  <sales-report-kw v-if="client === client_uuid.kw"></sales-report-kw>
  <div v-else class="sales-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="row mt-2">
            <div class="col-sm-10 col-form-label report-title">
              <span class="title-green"
                >{{ $t("report.coupon_reports") }}&nbsp</span
              >/<span class="title-black"
                >&nbsp{{ $t("report.sales_report") }}</span
              >
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <b-col
              cols="12"
              class="d-flex justify-content-center align-items-center"
            >
              <div class="col-4">
                <fieldset class="date-range-box-order-sales-reports">
                  <legend class="date-range-text">
                    {{ $t("report.filter_date_range_text") }}
                  </legend>
                  <b-input-group style="border: none !important;">
                    <date-range-picker
                      ref="drange"
                      :startDate="filter.startAt"
                      :endDate="filter.endAt"
                      @update="updateDateRange"
                      opens="left"
                      :locale-data="date_locale"
                      :ranges="ranges"
                    ></date-range-picker>
                  </b-input-group>
                </fieldset>
              </div>
            </b-col>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div
                    class="md-title card-number-stats"
                    style="margin-top: 50px"
                  >
                    <strong
                      >{{ currency.symbol_native }}{{ total_sales }}
                      {{ currency.code }}</strong
                    >
                  </div>
                </md-card-header>
                <md-card-content>{{
                  $t("report.card_total_sales")
                }}</md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
            </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div
                    class="md-title card-number-stats"
                    style="margin-top: 50px"
                  >
                    <strong>{{ total_transactions }}</strong>
                  </div>
                </md-card-header>
                <md-card-content>
                  {{ $t("report.card_total_transactions") }}
                </md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
            </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div
                    class="md-title card-number-stats"
                    style="margin-top: 50px"
                  >
                    <strong
                      >{{ currency.symbol_native }}{{ aov_value }}
                      {{ currency.code }}</strong
                    >
                  </div>
                </md-card-header>
                <md-card-content>
                  {{ $t("report.card_average_order_value") }}
                </md-card-content>
                <md-card-actions style="margin-top: 35px"></md-card-actions>
              </md-ripple>
            </md-card>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">
                    {{ $t("report.card_sales_channel_distribution") }}
                  </div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart
                      :height="250"
                      :chartData="salesChannelDistributionChartData"
                      :options="options"
                    ></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
            </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">
                    {{ $t("report.payment_method_distribution") }}
                  </div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart
                      :height="250"
                      :chartData="paymentMethodChartData"
                      :options="paymentDistributionChartOptions"
                    ></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
            </md-card>
          </div>
        </b-col>

        <b-col>
          <div class="report-card">
            <md-card md-with-hover>
              <md-ripple>
                <md-card-header>
                  <div class="md-title card-heading-stats">
                    {{ $t("report.delivery_vs_collection") }}
                  </div>
                </md-card-header>
                <md-card-content>
                  <div class="card-pie-chart">
                    <PieChart
                      :height="250"
                      :chartData="deliveryAndCollectionChartData"
                      :options="paymentDistributionChartOptions"
                    ></PieChart>
                  </div>
                </md-card-content>
              </md-ripple>
            </md-card>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4 mb-2 last-row">
        <b-col cols="12">
          <template v-if="overviewTableData.items.length">
            <md-table v-model="overviewTableData.items" md-card>
              <md-table-toolbar>
                <h1 class="md-title report-card card-heading-stats">
                  {{ $t("report.header_overview") }}
                </h1>
              </md-table-toolbar>

              <md-table-row class="mb-3 mt-4">
                <md-table-head
                  v-for="field in overviewTableData.fields"
                  :key="field.name"
                >
                  <span class="totals-row">{{ $t(field.label) }}</span>
                </md-table-head>
              </md-table-row>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  v-for="(field, index) in overviewTableData.fields"
                  :key="index"
                  :md-label="$t(field.label)"
                >
                  <span
                    v-html="handleShowValue(field, item)"
                    :class="{
                      'totals-row':
                        item.channel ==
                        overviewTableData.items[
                          overviewTableData.items.length - 1
                        ].channel
                    }"
                  >
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </template>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import PieChart from "@/components/Partials/PieChart";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import Multiselect from "vue-multiselect";
import SelectDropdown from "../../../components/Partials/SelectDropdown";
import BarChart from "../../../components/Partials/BarChart.vue";
import VueJsonToCsv from "vue-json-to-csv";
import SalesReportKw from './SalesReportKW.vue';

let vm = null;
const LABEL_OTHERS = "Others";
const TOTAL_CHEQUE = "Total Cheque";
const TOTAL_SALE = "Total Sales";
const AVG_CHEQUE = "Avg Cheque";

export default {
  name: "NewSalesReport",
  components: {
    DateRangePicker,
    PieChart,
    Multiselect,
    SelectDropdown,
    BarChart,
    VueJsonToCsv,
    SalesReportKw
  },
  data: function() {
    return {
      client: localStorage.getItem('clientID'),
      allStoresList: [],
      previousYearOptionSelected: "",
      filter: {
        startAt: this.$moment().format("YYYY-MM-DD"),
        endAt: this.$moment().format("YYYY-MM-DD")
      },
      total_sales: 0,
      total_transactions: 0,
      aov_value: 0,
      salesChannelDistributionChartData: {},
      paymentMethodChartData: {},
      deliveryAndCollectionChartData: {},
      comparedToPreviousYearChartData: {},
      salesChannelData: {},
      overviewTableData: {
        items: [],
        fields: [
          {
            name: "channel",
            label: "report.label_sales_channel"
          },
          {
            name: "transaction",
            label: "report.label_transactions"
          },
          {
            name: "sales",
            label: "report.label_sales",
            customValue: item => {
              return item.sales + " " + vm.currency.code;
            }
          },
          {
            name: "AOV",
            label: "report.label_aov",
            customValue: item => {
              return item.AOV + " " + vm.currency.code;
            }
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {},
        legend: {
          position: "right"
        }
      },
      paymentDistributionChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              let nameWithoutPercentage = data["labels"][
                tooltipItem["index"]
              ].replace(/[\W\d]/g, "");
              if (nameWithoutPercentage == LABEL_OTHERS) {
                return data["datasets"][0]["label"];
              } else {
                return `${nameWithoutPercentage} : ${
                  data["datasets"][0]["data"][tooltipItem["index"]]
                }`;
              }
            }
          }
        },
        legend: {
          position: "right"
        }
      },
      currency: this.$store.getters.config.gms.currency_info,
      delivery_carryout: null,
      payment_method: null,
      summary: null,
      useNewAPI: false
    };
  },
  methods: {
    handleShowValue(field, item) {
      return field.hasOwnProperty("customValue")
        ? field.customValue(item)
        : item[field.name];
    },
    getNewSalesReportData() {
      vm.refreshReportCards();
    },
    refreshReportCards() {
      const params = vm.getParams();
      if (vm.useNewAPI) {
        // vm.axios.campaign.getNewSalesOrderReportData(params, response => {
        //   vm.loadDataFromAPI(response.data.data);
        // });
        vm.axios.campaign.getNewSalesOrderReportDataV2(params, response => {
            vm.loadDataFromAPI(response.data.data);
          });
      } else {
        vm.axios.campaign.getNewSalesReportData(params, response => {
          vm.loadDataFromAPI(response.data);
        });
      }
    },
    loadReportCards() {
      vm.getSalesChannelDistributionData();
      vm.updateDeliveryCarryoutData(vm.delivery_carryout);
      vm.updateTransactionsData(vm.payment_method);
      vm.updateOverviewTableData();
    },
    formatPrice(value) {
      if (isNaN(value) || value === 0) {
        return "0.00";
      }

      if (typeof value === 'string') {
        value = parseFloat(value);
      }
      
      if (value) {
        return value
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    getParams() {
      let _data = {
        from_date: this.$moment(this.filter.startAt + " 00:00:00")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        to_date: this.$moment(this.filter.endAt + " 23:59:59")
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      };

      let params = "";
      for (let key in _data) {
        params += key + "=" + _data[key] + "&";
      }

      params = params.slice(0, -1);

      return params;
    },
    updateDateRange(val) {
      this.filter.startAt =
        val.startDate != null
          ? this.$moment(val.startDate).format("YYYY-MM-DD")
          : this.$moment().format("YYYY-MM-DD");
      this.filter.endAt =
        val.endDate != null
          ? this.$moment(val.endDate).format("YYYY-MM-DD")
          : this.$moment().format("YYYY-MM-DD");
      this.refreshReportCards();
    },
    getSalesChannelDistributionData() {
      let salesChannel = {};

      vm.salesChannelData.forEach(item => {
        salesChannel[item.channel] = parseFloat(item.total_sales);
      });

      const web = salesChannel["Web"] || 0;
      const androidApp = salesChannel["Android"] || 0;
      const iosApp = salesChannel["iOS"] || 0;
      const mobileWeb = salesChannel["Mobile Web"] || 0;
      const aggregator = salesChannel["Aggregator"] || 0;
      const callCenter =
        (salesChannel["Call Center"] || 0) + (salesChannel["0800"] || 0) || 0;
      const other =
        (salesChannel["Other"] || 0) + (salesChannel["iPad"] || 0) || 0;
      const totalSales =
        web + androidApp + iosApp + mobileWeb + aggregator + callCenter + other;
      const salesChannelPercent = {};
      salesChannelPercent["webPercent"] =
        totalSales > 0 ? ((web / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["androidAppPercent"] =
        totalSales > 0 ? ((androidApp / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["iosAppPercent"] =
        totalSales > 0 ? ((iosApp / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["mobileWebPercent"] =
        totalSales > 0 ? ((mobileWeb / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["aggregatorPercent"] =
        totalSales > 0 ? ((aggregator / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["callCenterPercent"] =
        totalSales > 0 ? ((callCenter / totalSales) * 100).toFixed() : 0;
      salesChannelPercent["otherPercent"] =
        totalSales > 0 ? ((other / totalSales) * 100).toFixed() : 0;
      const totalPercent = Object.values(salesChannelPercent).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );

      const maxSaleChannel = vm._.max(
        Object.keys(salesChannelPercent),
        k => salesChannelPercent[k]
      );
      salesChannelPercent[maxSaleChannel] =
        salesChannelPercent[maxSaleChannel] > 0
          ? parseFloat(salesChannelPercent[maxSaleChannel]) +
            (100 - parseFloat(totalPercent))
          : salesChannelPercent[maxSaleChannel];

      let labels = [];
      let data = [web, androidApp, iosApp, mobileWeb, other];
      if (this.isDisplayAggregatorReport()) {
        data.push(aggregator);
      }
      if (this.isDisplayCallCenterReport()) {
        data.push(callCenter);
      }

      data.sort(function(a, b) {
        return b - a;
      }); //desc

      data.forEach(val => {
        if (
          val == web &&
          labels.indexOf(
            vm.$t("report.web", { percent: salesChannelPercent.webPercent })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.web", { percent: salesChannelPercent.webPercent })
          );
        } else if (
          val == mobileWeb &&
          labels.indexOf(
            vm.$t("report.mobile_web", { percent: salesChannelPercent.mobileWebPercent })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.mobile_web", { percent: salesChannelPercent.mobileWebPercent })
          );
        } else if (
          val == androidApp &&
          labels.indexOf(
            vm.$t("report.android_app", {
              percent: salesChannelPercent.androidAppPercent
            })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.android_app", {
              percent: salesChannelPercent.androidAppPercent
            })
          );
        } else if (
          val == iosApp &&
          labels.indexOf(
            vm.$t("report.ios_app", {
              percent: salesChannelPercent.iosAppPercent
            })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.ios_app", {
              percent: salesChannelPercent.iosAppPercent
            })
          );
        } else if (
          val == aggregator &&
          this.isDisplayAggregatorReport() &&
          labels.indexOf(
            vm.$t("report.aggregator", {
              percent: salesChannelPercent.aggregatorPercent
            })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.aggregator", {
              percent: salesChannelPercent.aggregatorPercent
            })
          );
        } else if (
          val == callCenter &&
          this.isDisplayCallCenterReport() &&
          labels.indexOf(
            vm.$t("report.call_center", {
              percent: salesChannelPercent.callCenterPercent
            })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.call_center", {
              percent: salesChannelPercent.callCenterPercent
            })
          );
        } else if (
          val == other &&
          labels.indexOf(
            vm.$t("report.other", { percent: salesChannelPercent.otherPercent })
          ) == -1
        ) {
          labels.push(
            vm.$t("report.other", { percent: salesChannelPercent.otherPercent })
          );
        }
      });

      vm.salesChannelDistributionChartData = {
        labels,
        datasets: [
          {
            backgroundColor: [
              "#EAF6ED",
              "#DBF1E2",
              "#CDEBD6",
              "#B2E1C1",
              "#9FDAB3",
              "#8CD3A4",
              "#67C587"
            ],
            data
          }
        ]
      };
    },
    updateTransactionsData(paymentMethod) {
      const payment_method_with_percentage = [];
      const total_payments = [];
      let consolidatedPaymentTotal = 0;
      let consolidatedPaymentLabels = [];
      let consolidatedPaymentPercent = 0;
      if(paymentMethod) {
        paymentMethod.sort((a, b) => parseInt(b.total) - parseInt(a.total));

        paymentMethod.forEach(item => {
          const label = `${item.payment_method} ${item.in_percetage.toFixed(2)}%`;
          const value = item.total;
          if (total_payments.length > 5) {
            consolidatedPaymentTotal += parseInt(value);
            consolidatedPaymentPercent += parseInt(item.in_percetage.toFixed(2));
            consolidatedPaymentLabels.push(label + " : " + value);
          } else {
            payment_method_with_percentage.push(label);
            total_payments.push(value);
          }
        });

        if (consolidatedPaymentTotal > 0) {
          payment_method_with_percentage.push(
            `${LABEL_OTHERS} ${consolidatedPaymentPercent}%`
          );
          total_payments.push(consolidatedPaymentTotal);
        }
      }

      vm.paymentMethodChartData = {
        labels: payment_method_with_percentage,
        datasets: [
          {
            label: consolidatedPaymentLabels,
            backgroundColor: [
              "#67C587",
              "#8CD3A4",
              "#9FDAB3",
              "#B2E1C1",
              "#CDEBD6",
              "#DBF1E2",
              "#EAF6ED"
            ],
            data: total_payments
          }
        ]
      };
    },
    updateDeliveryCarryoutData(deliveryCarryout) {
      let percent_delivery = "0%";
      let percent_collection = "0%";
      let deliveryTotal = 0;
      let collectionTotal = 0;
      if (deliveryCarryout) {
        deliveryCarryout.forEach(item => {
          if (item.order_type == "delivery") {
            percent_delivery = item.in_percetage.toFixed(2) + "%";
            deliveryTotal = item.total;
          } else if (item.order_type == "carryout") {
            percent_collection = item.in_percetage.toFixed(2) + "%";
            collectionTotal = item.total;
          }
        });
      }
      vm.deliveryAndCollectionChartData = {
        labels: [
          vm.$t("report.delivery", { percent: percent_delivery }),
          vm.$t("report.collection", { percent: percent_collection })
        ],
        datasets: [
          {
            backgroundColor: ["#67C587", "#A9DEBA"],
            data: [deliveryTotal, collectionTotal]
          }
        ]
      };
    },
    updateOverviewTableData() {
      let web = { transaction: 0, sales: 0, AOV: 0, channel: "Web" };
      let ios = { transaction: 0, sales: 0, AOV: 0, channel: "iOS" };
      let appAndoid = { transaction: 0, sales: 0, AOV: 0, channel: "Android" };
      let mobileWeb = {
        transaction: 0,
        sales: 0,
        AOV: 0,
        channel: "Mobile Web"
      };
      let aggregator = {
        transaction: 0,
        sales: 0,
        AOV: 0,
        channel: "Aggregator"
      };
      let callCenter = {
        transaction: 0,
        sales: 0,
        AOV: 0,
        channel: "Call Center"
      };
      let other = { transaction: 0, sales: 0, AOV: 0, channel: "Other" };
      let totals = {
        transaction: 0,
        sales: 0,
        AOV: 0,
        channel: vm.$t("report.total")
      };
      vm.salesChannelData.forEach(item => {
        if (item.channel == "Web") {
          web.transaction = parseInt(item.total_cheques);
          web.sales = vm.formatPrice(parseFloat(item.total_sales.toFixed(2)));
          web.AOV = vm.formatPrice(parseFloat(item.avg.toFixed(2)));
        } else if (item.channel == "iOS") {
          ios.transaction = parseInt(item.total_cheques);
          ios.sales = vm.formatPrice(parseFloat(item.total_sales.toFixed(2)));
          ios.AOV = vm.formatPrice(parseFloat(item.avg.toFixed(2)));
        } else if (item.channel == "Android") {
          appAndoid.transaction = parseInt(item.total_cheques);
          appAndoid.sales = vm.formatPrice(parseFloat(item.total_sales.toFixed(2)));
          appAndoid.AOV = vm.formatPrice(parseFloat(item.avg.toFixed(2)));
        } else if (item.channel == "Mobile Web") {
          mobileWeb.transaction = parseInt(item.total_cheques);
          mobileWeb.sales = vm.formatPrice(parseFloat(item.total_sales.toFixed(2)));
          mobileWeb.AOV = vm.formatPrice(parseFloat(item.avg.toFixed(2)));
        } else if (item.channel == "Aggregator") {
          aggregator.transaction = parseInt(item.total_cheques);
          aggregator.sales = vm.formatPrice(parseFloat(item.total_sales.toFixed(2)));
          aggregator.AOV = vm.formatPrice(parseFloat(item.avg.toFixed(2)));
        } else if (item.channel == "Call Center" || item.channel == "0800") {
          callCenter.transaction += parseInt(item.total_cheques);
          callCenter.sales += parseFloat(item.total_sales.toFixed(2));
          callCenter.AOV = parseFloat(
            (callCenter.AOV + parseFloat(item.avg.toFixed(2))) / 2
          ).toFixed(2);
        } else if (item.channel == "Other" || item.channel == "iPad") {
          other.transaction += parseInt(item.total_cheques);
          other.sales += parseFloat(item.total_sales.toFixed(2));
          other.AOV = parseFloat(
            (other.AOV + parseFloat(item.avg.toFixed(2))) / 2
          );
        }
        totals.transaction += parseInt(item.total_cheques);
        totals.sales += parseFloat(item.total_sales.toFixed(2));
      });
      callCenter.sales = vm.formatPrice(callCenter.sales);
      callCenter.AOV = vm.formatPrice(callCenter.AOV);
      other.sales = vm.formatPrice(other.sales);
      other.AOV = vm.formatPrice(other.AOV);

      //Refactor
      totals.sales = vm.formatPrice(totals.sales);
      totals.AOV = vm.aov_value;
      //push
      vm.overviewTableData.items = [];
      vm.overviewTableData.items.push(web);
      vm.overviewTableData.items.push(ios);
      vm.overviewTableData.items.push(appAndoid);
      vm.overviewTableData.items.push(mobileWeb);
      if (this.isDisplayAggregatorReport()) {
        vm.overviewTableData.items.push(aggregator);
      }
      if (this.isDisplayCallCenterReport()) {
        vm.overviewTableData.items.push(callCenter);
      }
      vm.overviewTableData.items.push(other);
      vm.overviewTableData.items.push(totals);
    },
    getSpanText(item) {
      return ` ${item.length} options selected`;
    },
    isDisplayAggregatorReport() {
      const config = vm.$session.get("config");
      const manualConfig = vm._.get(config, "manual_config", {}) || {};
      if (
        manualConfig.display_aggregator_report &&
        manualConfig.display_aggregator_report == true
      ) {
        return true;
      }
      return false;
    },
    isDisplayCallCenterReport() {
      const config = vm.$session.get("config");
      const manualConfig = vm._.get(config, "manual_config", {}) || {};
      if (
        manualConfig.display_callcenter_report &&
        manualConfig.display_callcenter_report == true
      ) {
        return true;
      }
      return false;
    },
    useNewApiNewSaleReport() {
      const config = vm.$session.get("config");
      const manualConfig = vm._.get(config, "manual_config", {}) || {};
      if (
        manualConfig.use_new_api_sale_report &&
        manualConfig.use_new_api_sale_report == true
      ) {
        return true;
      }
      return false;
    },
    loadDataFromAPI(data) {
      vm.summary = data.summary;
      vm.delivery_carryout = data.delivery_carryout;
      vm.payment_method = data.payment_method;
      vm.salesChannelData = data.mobile_desktop;
      vm.aov_value = vm.formatPrice(vm.summary.avg);
      vm.total_sales = vm.formatPrice(vm.summary.total_sales);
      vm.total_transactions = vm.summary.total_cheques;
      vm.loadReportCards();
    }
  },
  computed: {
    date_locale: function() {
      let format = this.format_date_range_locale();
      format.format = "YYYY/MM/DD";
      if (this.$refs.drange) {
        this.$refs.drange.locale = format;
      }
      return format;
    },
    ranges: function() {
      return this.format_date_ranges();
    }
  },
  created: function() {
    vm = this;
    vm.useNewAPI = vm.useNewApiNewSaleReport();
    vm.getNewSalesReportData();
    vm.newSaleReportChangeLang = () => {
      if (
        vm.delivery_carryout !== null &&
        vm.payment_method !== null &&
        vm.summary !== null
      ) {
        vm.loadReportCards();
      }
    };
    vm.$root.$on("changeLang", vm.newSaleReportChangeLang);
  },
  beforeDestroy() {
    vm.$root.$off("changeLang", vm.newSaleReportChangeLang);
  }
};
</script>
<style scoped>
.sales-report-list ::selection {
  background-color: #d7d7d7 !important;
  color: #000;
}
.report-card {
  text-align: center;
}
.card-details {
  text-align: center;
  font-size: 26px;
}
.card-number-stats {
  font-weight: 700 !important;
  font-size: 38px !important;
  line-height: 32px !important;
}
.card-heading-stats {
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700 !important;
  font-size: 24px;
  line-height: 28px;
  color: #231f20;
}
.table-text {
  width: 87px;
  height: 24px;
  /* font-family: 'Open Sans'; */
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #333333;
  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}
.totals-row {
  font-weight: 700;
  /* font-size: 16px; */
  line-height: 24px;
  color: #333333;
  flex: none;
  order: 1;
  flex-grow: 0;
}
.report-title {
  /* font-family: 'Sharp Sans Display No1'; */
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
}
.title-green {
  color: #038900;
}
.title-black {
  color: #000000;
}
.date-range-box-order-sales-reports {
  border: 1px solid #00000026;
  border-radius: 3px;
  width: 70%;
  margin: 0 auto;
}
.date-range-text {
  font-size: 12px;
  margin-left: 10px;
  width: max-content;
  color: #6b6e79;
  margin-bottom: -3px;
}
.btn-success {
  color: #fff;
  background-color: #0a8020 !important;
  border-color: #4dbd74;
  font-size: 0.95rem;
}
.bar-chart-select-option {
  margin: 0 auto;
  display: -webkit-inline-box;
}
</style>
<style>
.md-table-head {
  color: #000000 !important;
}

.date-range-box-order-sales-reports > .input-group > div > div.form-control {
  border: none !important;
}

.md-table-head-label {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.sales-report-list .last-row .md-card {
  height: 100% !important;
}

.sales-report-list .last-row .md-table-content {
  margin-top: 3em;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.sales-report-list .sales-hut-selection .multiselect__tags {
  max-width: 94% !important;
  min-width: 94% !important;
}
.sales-report-list .sales-hut-selection .multiselect__select {
  right: 30px !important;
}
.sales-report-list .sales-hut-selection .multiselect__content-wrapper {
  width: 94% !important;
}
.bar-chart-select-option .multiselect__tags {
  max-width: 220px;
  min-width: 220px;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/report/NewSalesReport.vue